module.exports = __webpack_public_path__ + "img/1-Menu-Principale.a9ca636a.jpg";